/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemService } from '@pt/api-client';
import { LogLevel } from 'it/primatoo/openapi/api/common/schemas/LogLevel';

@Component({
  selector: 'pt-system-log-dialog',
  template: `
    <!--    <div class='modal-header'-->
    <!--         (click)='$event.stopPropagation()'>-->
    <!--      <h4 class='modal-title'>-->
    <!--        {{ 'PAGE.TOOLS.LOGS.DIALOG_TITLE' | translate }}-->
    <!--      </h4>-->
    <!--    </div>-->
    <div class='modal-header' (click)='$event.stopPropagation()'></div>

    <div class='modal-body' (click)='$event.stopPropagation()'>
      <!--      <p [innerHTML]=" 'PAGE.TOOLS.LOGS.DIALOG_DESCRIPTION' | translate"></p>-->

      <table class='table table-striped table-sm m-0 w-100'>
        <thead class='bg-secondary text-white'>
        <tr>
          <td>Microservizio</td>
          <td class="text-center action-col">Stato</td>
          <td class="text-center action-col">Log</td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>
            <div class="heartbeat-container-org">
              Admin
            </div>
          </td>
          <td class="text-center">
            <div class="heartbeat-container">
              <div class="heartbeat" [ngClass]="adminHeartBeat ? 'bg-success' : 'bg-danger'"></div>
            </div>
          </td>
          <td>
            <select class="form-select form-select-sm log-height"
                    (ngModelChange)="changeAdminLogLevel($event)"
                    [(ngModel)]="adminLogLevel">
              <option value="{{r}}" *ngFor="let r of selectOptions">
                {{ ('ENUMS.' + r) | translate }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <div class="heartbeat-container-org">
              Security
            </div>
          </td>
          <td class="text-center">
            <div class="heartbeat-container">
              <div class="heartbeat" [ngClass]="secHeartBeat ? 'bg-success' : 'bg-danger'"></div>
            </div>
          </td>
          <td>
            <select class="form-select form-select-sm log-height"
                    (ngModelChange)="changeSecLogLevel($event)"
                    [(ngModel)]="secLogLevel">
              <option value="{{r}}" *ngFor="let r of selectOptions">
                {{ ('ENUMS.' + r) | translate }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <div class="heartbeat-container-org">
              Organization
            </div>
          </td>
          <td>
            <div class="heartbeat-container">
              <div class="heartbeat" [ngClass]="orgHeartBeat ? 'bg-success' : 'bg-danger'"></div>
            </div>
          </td>
          <td>
            <select class="form-select form-select-sm log-height"
                    (ngModelChange)="changeOrgLogLevel($event)"
                    [(ngModel)]="orgLogLevel">
              <option value="{{r}}" *ngFor="let r of selectOptions">
                {{ ('ENUMS.' + r) | translate }}
              </option>
            </select>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CLOSE' | translate }}
      </button>
    </div>
  `,
  styles: [`
    .log-height {
      height: 28px;
    }

    .heartbeat-container-org {
      width: 100%;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }


    .heartbeat-container {
      width: 100%;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .heartbeat {
      width: 10px;
      height: 10px;
      border-radius: 25px;
    }
    .action-col {
      width: 120px;
    }

  `]
})
export class SystemLogDialogComponent implements OnInit {
  public adminHeartBeat: any;
  public secHeartBeat: any;
  public orgHeartBeat: any;

  public adminLogLevel?: LogLevel;
  public secLogLevel?: LogLevel;
  public orgLogLevel?: LogLevel;

  public selectOptions: string[] = Object.keys(LogLevel);

  constructor(public activeModal: NgbActiveModal,
              public systemService: SystemService) {
  }

  ngOnInit(): void {
    this.loadHeartbeat();
    this.loadLogLevel();
  }

  private loadHeartbeat() {
    this.systemService.getAdminHeartbeat().subscribe({
      next: () => {
        this.adminHeartBeat = true;
      }, error: () => {
        this.adminHeartBeat = false;
      }
    });

    this.systemService.getSecHeartbeat().subscribe({
      next: () => {
        this.secHeartBeat = true;
      }, error: () => {
        this.secHeartBeat = false;
      }
    });

    this.systemService.getOrgHeartbeat().subscribe({
      next: () => {
        this.orgHeartBeat = true;
      }, error: () => {
        this.orgHeartBeat = false;
      }
    });
  }

  private loadLogLevel(): void {
    this.systemService.getAdminLogLevel().subscribe({
      next: (res) => {
        this.adminLogLevel = res.level;
      }, error: () => {
        this.adminLogLevel = undefined;
      }
    });

    this.systemService.getSecLogLevel().subscribe({
      next: (res) => {
        this.secLogLevel = res.level;
      }, error: () => {
        this.secLogLevel = undefined;
      }
    });

    this.systemService.getOrgLogLevel().subscribe({
      next: (res) => {
        this.orgLogLevel = res.level;
      }, error: () => {
        this.orgLogLevel = undefined;
      }
    });
  }

  changeAdminLogLevel(logLevel: LogLevel) {
    this.systemService.upsertAdminLogLevel(logLevel).subscribe({
      next: () => {
        this.loadLogLevel();
      }, error: () => {
        this.loadLogLevel();
      }
    });
  }

  changeSecLogLevel(logLevel: LogLevel) {
    this.systemService.upsertSecLogLevel(logLevel).subscribe({
      next: () => {
        this.loadLogLevel();
      }, error: () => {
        this.loadLogLevel();
      }
    });
  }

  changeOrgLogLevel(logLevel: LogLevel) {
    this.systemService.upsertOrgLogLevel(logLevel).subscribe({
      next: () => {
        this.loadLogLevel();
      }, error: () => {
        this.loadLogLevel();
      }
    });
  }
}

